import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const jwtKey = "token";

axios.interceptors.request.use(
    (config: any) => {
        const { origin } = new URL(config.url);
        const allowedOrigins = [apiUrl];
        const accessToken = localStorage.getItem(jwtKey);
        config.headers.authorization = `Bearer ${accessToken}`;
        // if (allowedOrigins.includes(origin)) {
        // }
        return config;
    },
    (error: any) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle authentication errors
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearStorage(); // Clear token and any stored data
            window.location.href = "/login"; // Redirect to login page
        }
        return Promise.reject(error);
    }
);

export const createUrl = (endpoint: string) => new URL(endpoint, apiUrl).href;
export const isStoredJwt = () => Boolean(localStorage.getItem(jwtKey));
export const setStoredJwt = (accessToken: string) =>
    localStorage.setItem(jwtKey, accessToken);

export const clearStorage = ()=> {
    localStorage.clear();    
};

export const getReq = axios.get;
export const patchReq = axios.patch;
export const postReq = axios.post;
export const putReq = axios.put;
export const deleteReq = axios.delete;